<section
  [attr.aria-label]="courseName ? courseName + ' content' : 'Course content'"
  [attr.inert]="isVisible ? '' : null">
  <div class="container mx-auto h-screen overflow-y-clip">
    <iframe id="course-iframe" [src]="blobUrl" width="100%" height="100%"
      [title]="courseName ? courseName + ' course content' : 'Course content'"
      (load)="startMonitoringCourseProgress()"></iframe>
  </div>
</section>

<div *ngIf="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
  role="dialog" aria-modal="true" aria-labelledby="modal-title" (keydown.escape)="handleCancel()">
      <div class="bg-white rounded-lg shadow-xl w-full max-w-3xl max-h-[90vh] mx-4 overflow-y-auto outline-none"
        #modalContainer>
        <div class="flex justify-between items-center border-b px-6 py-4">
          <h2 id="modal-title" class="text-lg font-semibold text-gray-800">{{ courseName }}</h2>
          <button (click)="handleCancel()" aria-label="Close modal"
            class="text-gray-500 hover:text-gray-700 focus:outline-none">
            <i class="uil uil-times text-xl"></i>
          </button>
        </div>

        <div class="px-6 py-4 space-y-4">
          <div class="flex justify-between items-center">
            <h3 class="text-gray-700 text-base font-medium">Course Sections</h3>
            <span class="text-sm text-gray-600">
              {{ calculateProgress().completed }} / {{ calculateProgress().total }} Complete
            </span>
          </div>

          <div class="space-y-4">
            <div *ngFor="let section of sections" class="border rounded-md overflow-hidden">
              <button
                class="w-full flex justify-between items-center px-4 py-3 bg-gray-100 hover:bg-gray-200 focus:outline-none"
                (click)="activePanel = activePanel === section.id ? null : section.id"
                [attr.aria-expanded]="activePanel === section.id" [attr.aria-controls]="'section-' + section.id">
                <div class="flex items-start gap-2 text-left -ml-2">
                  <span [class.text-green-500]="isSectionComplete(section.id)"
                    [class.text-gray-300]="!isSectionComplete(section.id)">
                    <i nz-icon nzType="check-circle" nzTheme="fill"></i>
                  </span>
                  <div class="flex items-center gap-2">
                    <span class="transform transition-transform duration-200" [ngClass]="{
                      'rotate-90': activePanel === section.id,
                      'rotate-0': activePanel !== section.id
                    }">
                      <i class="uil uil-angle-right text-gray-500"></i>
                    </span>
                    <span [innerHTML]="section.sectionName" class="font-medium text-gray-800"></span>
                  </div>

                </div>
                <div class="text-sm text-gray-500">
                  <span class="text-sm px-3 py-1 rounded-full" [style]="
                  isSectionComplete(section.id)
                    ? { color: '#15803d', 'background-color': '#f0fdf4' }
                    : { color: '#4b5563', 'background-color': '#f9fafb' }
                ">
                    {{ isSectionComplete(section.id) ? 'Completed' : 'Incomplete' }}
                  </span>
                </div>
              </button>
              <hr *ngIf="activePanel === section.id">

              <div [id]="'section-' + section.id" [hidden]="activePanel !== section.id"
                class="p-4 bg-white space-y-4 overflow-hidden">
                <p [innerHTML]="section.description"></p>

                <ng-container *ngFor="let entry of journalEntries">
                  <div *ngIf="entry.journalSectionId === section.id" class="bg-gray-50 rounded-lg p-4">
                    <div class="flex justify-between items-start mb-2">
                      <span class="text-sm font-semibold text-gray-500">{{
                        entry.dateSubmitted | date : 'longDate'
                        }}</span>
                      <prism-btn *ngIf="!readOnly" variant="text" [ariaLabel]="'Edit PRISM Digital Notebook entry from ' + (entry.dateSubmitted | date : 'longDate')" (click)="editEntry($event, entry)">
                        <i class="uil uil-edit" aria-hidden="true"></i>
                      </prism-btn>
                    </div>
                    <p class="text-gray-600 break-words whitespace-pre-wrap">{{ entry.entry }}</p>
                  </div>
                </ng-container>

                <form *ngIf="section.showEntryForm" [formGroup]="journalForm" (ngSubmit)="
                  editingEntryId
                    ? updateJournalEntry(section.id, section.minEntryLimit)
                    : submitJournalEntry(section.id, section.minEntryLimit)
                    " class="space-y-4">
                  <div>
                    <prism-input [control]="entry"
                      [label]="editingEntryId ? 'Edit PRISM Digital Notebook Entry' : 'PRISM Digital Notebook Entry'"
                      placeHolder="Enter PRISM Digital Notebook entry" [inputType]="InputType.Textarea"
                      [minLength]="section.minEntryLimit" [maxLength]="2000"></prism-input>
                  </div>

                  <div class="flex justify-end gap-2">
                    <prism-btn *ngIf="editingEntryId" variant="text" btnClass="btn-danger" btnType="button"
                      (click)="deleteEntry($event)">
                      Delete
                    </prism-btn>
                    <prism-btn variant="text" btnType="button" (click)="cancelEntry($event)">Cancel</prism-btn>
                    <prism-btn variant="primary" [disabled]="!journalForm.valid">{{
                      editingEntryId ? 'Save Edit' : 'Save Entry'
                      }}</prism-btn>
                  </div>
                </form>

                <div *ngIf="!section.showEntryForm && !readOnly">
                  <prism-btn variant="outline" class="w-full mt-2" (click)="showEntryForm($event, section.id)">
                    <i nz-icon nzType="plus"></i>
                    Add PRISM Digital Notebook Entry
                  </prism-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>